<template>
    <sub-page class="m-editCollectMap">
        <div class="collect-map-box">
            <div class="img-wrap-ratio">
                <image-marker
                    ref="imageMarker"
                    :imageUrl="imageUrl"
                    :imageMark="imageMark"
                    :disabled="ruleForm.isSafe"
                ></image-marker>
            </div>
        </div>

        <el-form class="collect-map-form form-omit"
                 :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" size="small">

            <div class="form-part part-image">
                <h3>图像信息</h3>

                <el-form-item label="物品图像" required>
                    <el-upload
                        class="upload-demo"
                        :action="imgUpload.api"
                        :data="imgUpload.params"
                        accept=".jpg,.jpeg,.bmp,.png"
                        name="upfile"
                        :show-file-list="false"
                        :on-success="onImageUpload"
                    >
                        <el-button class="btn-upload" :type="ruleForm.baseUrl?'':'primary'" size="small">
                            <template v-if="!ruleForm.baseUrl">
                                <i class="nucfont inuc-daorutupian"></i>上传{{label}}图像
                            </template>
                            <template v-else>
                                <i class="nucfont inuc-reset"></i>重新上传
                            </template>
                        </el-button>
                    </el-upload>
                </el-form-item>

                <!-- 物品名称 -->
                <el-form-item label="物品名称" prop="imageName">
                    <el-input v-model="ruleForm.imageName" :placeholder="$t('tip.name')" clearable></el-input>
                </el-form-item>
                <!-- 物品种类 -->
                <el-form-item label="物品种类" prop="knowledgeId">
                    <el-cascader
                        v-model="ruleForm.knowledgeId"
                        :options="markKnowledgeMenu"
                        :props="cascadeProp"
                        :show-all-levels="false"
                        clearable
                    ></el-cascader>
                </el-form-item>

                <!-- 图像类型 -->
                <el-form-item label="图像类型" prop="isSafe" v-if="!isOmit">
                    <el-radio-group v-model="ruleForm.isSafe" prop="isSafe">
                        <el-radio :label="false">嫌疑</el-radio>
                        <el-radio :label="true">安全</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 通道 -->
                <el-form-item label="通道" prop="channel">
                    <el-input v-model="ruleForm.channel" placeholder="请输入通道" clearable></el-input>
                </el-form-item>
                <!-- 通道种类 -->
                <el-form-item label="通道类型" prop="channelType">
                    <el-select v-model="ruleForm.channelType" collapse-tags placeholder="选择通道类型" clearable>
                        <el-option label="普客" :value="1"></el-option>
                        <el-option label="商务" :value="2"></el-option>
                        <el-option label="急客" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 漏检时间 -->
                <el-form-item :label="`${label}时间`">
                    <el-date-picker
                        v-model="ruleForm.inspectTime"
                        type="datetime"
                        style="width: 225px"
                        format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="`选择${label}时间`"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <!-- 漏检图像属性 -->
                <el-form-item :label="`${label}结果`" prop="articleStatus">
                    <el-select v-model="ruleForm.articleStatus" collapse-tags :placeholder="`选择${label}结果`" clearable>
                        <el-option label="已追回" :value="1"></el-option>
                        <el-option label="未追回" :value="2"></el-option>
                        <el-option label="已登记" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 漏检图像属性 -->
                <el-form-item label="图像属性" prop="imageProperty">
                    <el-select v-model="ruleForm.imageProperty" collapse-tags placeholder="选择漏检图像属性" clearable>
                        <el-option label="图像特征被遮挡" :value="1"></el-option>
                        <el-option label="图像颜色淡" :value="2"></el-option>
                        <el-option label="开机员判图不全" :value="3"></el-option>
                        <el-option label="违禁品图像过检角度特殊" :value="4"></el-option>
                        <el-option label="其他" :value="5"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 漏检图像描述 -->
                <el-form-item label="图像描述" prop="imageDescription">
                    <el-input type="textarea"
                              v-model="ruleForm.imageDescription"
                              :autosize="{ minRows: 2, maxRows: 5}"></el-input>
                </el-form-item>
            </div>

            <div class="form-part part-watch">
                <h3>安检员信息</h3>

                <el-form-item label="安检员" prop="watchName">
                    <el-autocomplete
                        v-model="ruleForm.watchName"
                        :fetch-suggestions="queryWatchAsync"
                        placeholder="输入姓名/账号后，进行选择"
                        @select="handleSelectWatch"
                        @blur="checkInputWatch"
                    >
                        <div slot-scope="{ item }" style="line-height: normal;padding: 7px 0;">
                            <div class="name" style="text-overflow: ellipsis;overflow: hidden;">{{ item.value }}</div>
                            <span class="org" style="font-size: 12px;color: #b4b4b4;">{{ item.orgName }}</span>
                        </div>
                    </el-autocomplete>
                </el-form-item>

                <el-form-item label="组织机构" v-if="isBackend" prop="orgID">
                    <el-popover
                        v-model="orgPopover"
                        placement="right-start"
                        trigger="click">
                        <select-SingleOrg
                            class="tree-container-pop"
                            style="width: 300px"
                            ref="treeOrg"
                            :isTreePop="true"
                            :defaultCheck="this.ruleForm.orgID"
                            v-on:getTreeNodeData="selectOrgs"
                        ></select-SingleOrg>
                        <el-input v-model="ruleForm.orgName" slot="reference" :placeholder="$t('tip.belong')"
                                  readonly></el-input>
                        <input type="hidden" :value="ruleForm.orgID">
                    </el-popover>
                </el-form-item>
                <el-form-item label="组织机构" v-else>
                    <el-input v-model="watch.orgName" placeholder="请先选择安检员" disabled></el-input>
                </el-form-item>
                <el-form-item label="工号" v-show="watch.jobNo">
                    <el-input v-model="watch.jobNo" placeholder="-" disabled></el-input>
                </el-form-item>
                <el-form-item label="性别" v-show="watch.sexName">
                    <el-input v-model="watch.sexName" placeholder="-" disabled></el-input>
                </el-form-item>
                <el-form-item label="资质" v-show="watch.gradeName">
                    <el-input v-model="watch.gradeName" placeholder="-" disabled></el-input>
                </el-form-item>
            </div>

            <div class="form-part part-passenger">
                <h3>旅客信息</h3>
                <el-form-item label="旅客姓名" prop="passengerName">
                    <el-input v-model="ruleForm.passengerName" placeholder="输入旅客姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="passengerGender">
                    <el-radio-group v-model="ruleForm.passengerGender" prop="passengerGender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄" prop="ageRanges">
                    <el-select v-model="ruleForm.ageRanges" collapse-tags placeholder="选择旅客年龄" clearable>
                        <el-option label="18岁以下" :value="1"></el-option>
                        <el-option label="19-44" :value="2"></el-option>
                        <el-option label="45-59" :value="3"></el-option>
                        <el-option label="60以上" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="身份" prop="passengerType">
                    <el-select v-model="ruleForm.passengerType" collapse-tags placeholder="选择旅客身份" clearable>
                        <el-option label="特殊旅客" :value="1"></el-option>
                        <el-option label="国内商务旅客" :value="2"></el-option>
                        <el-option label="海外商务旅客" :value="3"></el-option>
                        <el-option label="旅行团" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="航班号" prop="flight">
                    <el-input v-model="ruleForm.flight" placeholder="输入航班号" clearable></el-input>
                </el-form-item>
                <el-form-item label="航班性质" prop="flightNature">
                    <el-select v-model="ruleForm.flightNature" collapse-tags placeholder="选择航班性质" clearable>
                        <el-option label="高峰期" :value="1"></el-option>
                        <el-option label="次峰期" :value="2"></el-option>
                        <el-option label="非峰期" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否为转机旅客">
                    <el-radio-group v-model="ruleForm.isTransfer" prop="isTransfer">
                        <el-radio :label="false">否</el-radio>
                        <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
        </el-form>

        <div class="btn-group">
            <el-button type="primary" @click="toSubmit" :loading="submitLoading" size="medium">提交</el-button>
        </div>

    </sub-page>
</template>

<script>
    import {mapGetters} from 'vuex'
    import SubPage from '@/components/Subpage.vue'
    import {Ticket, Cascade} from '@/utils'
    import selectSingleOrg from '@/components/SelectSingleOrg.vue'
    import ImageMarker from "@/components/Image/ImageMarker"
    const config = require('@/config')
    const imgURL = `${config.baseUrl}/fileapi/WebUploader/UEditor`

    export default {
        props: ['id'],
        components: {
            SubPage,
            selectSingleOrg,
            ImageMarker
        },
        data() {
            let isOmit = this.$route.name.indexOf('Omit') > -1
            let isBackend = this.$route.name.indexOf('BG') > -1
            let orgObj = isBackend ? {orgID: '', orgName: ''} : {}

            return {
                isOmit,  // 是否为漏检图
                isBackend, // 身份是否为后台（分科室和后台两种身份）
                ruleForm: {
                    imageName: '',
                    knowledgeId: '',
                    isSafe: '',
                    baseUrl: '',
                    channel: '',
                    channelType: '',
                    inspectTime: '',
                    imageProperty: '',
                    imageDescription: '',
                    articleStatus: '',

                    watchId: '',
                    watchName: '',
                    ...orgObj,

                    passengerName: '',
                    passengerGender: '',
                    ageRanges: '',
                    passengerType: '',
                    flight: '',
                    flightNature: '',
                    isTransfer: '',
                },
                watch: {
                    jobNo: '',
                    sexName: '',
                    orgName: '',
                    gradeName: '',
                },
                rules: {
                    imageName: [
                        {required: true, message: '请输入物品名称', trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ],
                    knowledgeId: [{required: true, message: '请选择物品种类', trigger: 'change'}],
                    isSafe: [{required: true, message: '请选择图像类型', trigger: 'change'}],
                    channel: [{max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}],
                    flight: [{max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}],
                    imageDescription: [{max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}],
                    watchName: [{max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}],
                    orgID: [{required: true, message: '请选择组织机构', trigger: 'change'}],
                    passengerName: [{max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}],
                },

                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                orgPopover: false,
                submitLoading: false,

                imgUpload: {
                    api: imgURL,
                    params: {
                        'access_token': Ticket.get().access_token
                    },
                },
                imageUrl: '',
                imageMark: []
            }
        },

        computed: {
            ...mapGetters([
                'markKnowledgeMenu',
            ]),
            label() {
                return this.isOmit ? '漏检' : '过检'
            }
        },

        mounted() {
            if (this.id) {
                this.fillData()
            }
        },

        watch: {
            // 若为安全包，则清除标框，并不可标框
            'ruleForm.isSafe'(isSafe) {
                if (isSafe) {
                    this.$refs.imageMarker.clearMarkInfo()
                }
            }
        },

        methods: {
            async fillData() {
                let res = await this.$api.getOmitDetail(this.id)
                let data = res.package
                console.log(data)

                // 加载表单信息
                for (let item in data) {
                    if (this.ruleForm.hasOwnProperty(item)) {
                        // 服务端会对无值的枚举下拉菜单返回0
                        if (data[item] === 0) {
                            data[item] = ''
                        }

                        if (item === 'knowledgeId') {
                            this.ruleForm.knowledgeId = Cascade.fullPath(this.markKnowledgeMenu, data.knowledgeId)
                            continue
                        }

                        this.ruleForm[item] = data[item]
                    }
                }

                // 加载安检员信息
                if (data.watchId || data.orgId) {
                    let watchData = {
                        ...data,
                        id: data.watchId,
                        orgID: data.orgId,
                        name: data.watchName
                    }

                    this.handleSelectWatch(watchData)
                }

                // 加载图像信息
                this.imageUrl = data.baseUrl
                this.imageMark = data.imageMarker.map(item => {
                    return {
                        answerId: item.knowledgeId,
                        answerName: item.knowledgeName,
                        rectangle: item.rectangle
                    }
                })
            },

            queryWatchAsync(queryString, cb) {
                if (!queryString.trim()) {
                    return cb([])
                }

                this.$api.queryUsers({search: queryString}).then(res => {
                    let data = res.package
                    if (!data.length) {
                        return cb([])
                    }

                    data.forEach(item => {
                        item.value = item.name
                    })

                    return cb(data)
                })
            },
            handleSelectWatch(data) {
                for (let item in data) {
                    if (this.watch.hasOwnProperty(item)) {
                        this.watch[item] = data[item]
                    }
                }
                this.ruleForm.watchId = data.id

                if (this.isBackend) {
                    this.ruleForm.orgID = data.orgID
                    this.ruleForm.orgName = data.orgName
                }

                this.selectedWatchName = data.name
            },
            checkInputWatch() {
                setTimeout(() => {
                    // 如果选完人，结果把名字改了（且有值）
                    if (this.selectedWatchName && this.ruleForm.watchName) {
                        if (this.selectedWatchName !== this.ruleForm.watchName) {
                            this.clearWatch()
                        }
                    } else {
                        // 没匹配到
                        this.clearWatch()
                    }
                }, 100)
            },
            clearWatch() {
                this.ruleForm.watchId = ''
                this.ruleForm.watchName = ''
                this.selectedWatchName = ''
                for (let item in this.watch) {
                    this.watch[item] = ''
                }
            },

            onImageUpload(res, file) {
                if (!res.result) return this.$message.error(res.message || res.state)

                this.ruleForm.baseUrl = res.url
                this.imageUrl = res.url
                this.imageMark = []
            },


            selectOrgs(data) {
                this.ruleForm.orgID = data.id
                this.ruleForm.orgName = data.name
                this.orgPopover = false
            },

            // 获取图的原始尺寸
            getImageSize() {
                return new Promise((resolve) => {
                    let img = new Image()
                    img.src = this.ruleForm.baseUrl
                    img.onload = function () {
                        resolve([img.width, img.height])
                    }
                })
            },
            // 获取框的数据
            getImageMarker(markInfo, w, h) {
                let imageMarker = markInfo.map(item => {
                    // (A,B)为左上角坐标，(C,D)为右下角坐标
                    //let [A, B, C, D] = item.rectangle.split(',')

                    return {
                        knowledgeId: item.answerId,
                        knowledgeName: item.answerName,
                        // xCoordinate: A * w,
                        // yCoordinate: B * h,
                        // width: (C - A) * w,
                        // height: (D - B) * h
                        rectangle: item.rectangle,
                    }
                })

                return imageMarker
            },

            async toSubmit() {
                this.$refs['ruleForm'].validate(async (valid) => {
                    if (!valid) return

                    if (!this.ruleForm.baseUrl) {
                        return this.$message.error('请上传物品图像！')
                    }

                    // 获取图像原始宽高
                    let [width, height] = await this.getImageSize()

                    // 标图数据
                    let markInfo = this.$refs.imageMarker.getUserMarkedRectanglesInfo()
                    let imageMarker = this.getImageMarker(markInfo, width, height)

                    let postData = {
                        ...this.ruleForm,
                        knowledgeId: this.ruleForm.knowledgeId[this.ruleForm.knowledgeId.length - 1],
                        imageWidth: width,
                        imageHeight: height,
                        imageMarker
                    };

                    // 漏检图都是嫌疑包
                    if (this.isOmit) postData.isSafe = false

                    // 嫌疑包必须标框
                    if (!postData.isSafe && markInfo.length < 1) {
                        return this.$message.error('请在图像中标记嫌疑物位置！')
                    }

                    // 服务端说枚举只能传number类型.. orz
                    ['channelType', 'articleStatus', 'imageProperty', 'passengerGender', 'ageRanges', 'passengerType', 'flightNature', 'isTransfer'].forEach(item => {
                        if (!postData[item] && postData[item]!==false) {
                            delete postData[item]
                        }
                    })

                    this.submitLoading = true

                    if (this.id) {
                        this.$api.editOmit(this.id, postData).then(res => {
                            this.submitSuccess(res)
                        }).catch(error => this.submitLoading = false)
                    } else {

                        // 添加功能，需区分漏检优质和科室后台
                        this.$api.postOmit(postData,{params: {
                                source: this.isOmit ? 1: 2,
                                isBackstage: this.isBackend,
                                culture: this.$i18n.locale,
                                'ui-culture': this.$i18n.locale
                            }}).then(res => {
                            this.submitSuccess(res)
                        }).catch(error => this.submitLoading = false)
                    }

                })
            },

            submitSuccess(res) {
                let message = this.id ? this.$t('m.editSuccess'): this.$t('m.addSuccess')

                this.submitLoading = false
                this.$notify({
                    title: res.message,
                    message,
                    type: 'success',
                    duration: 2000
                })

                this.$emit('onClose')
                this.$router.back()
            }


        },
    }
</script>

<style lang="scss">
    @import '~@/style/const.scss';

    .m-editCollectMap {
        .el-card__body {
            /*display: flex;*/
            /*justify-content: space-between;*/
            margin-left: 45%;
        }

        .collect-map-box {
            position: absolute;
            top: 50%;
            left: 60px;
            transform: translateY(-50%);
            width: 40%;
            border: 1px solid #dedede;

            .img-wrap-ratio {
                padding-top: 100%;
            }

            .image-marker-container {
                position: absolute !important;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

        }

        .collect-map-form {
            flex: 1;
            padding: 0 20px;
        }

        .form-part {
            padding-bottom: 10px;

            > h3 {
                width: 300px;
                padding: 10px 15px;
                margin-bottom: 18px;
                font-size: 16px;
                background-color: #F2F4FD;
            }

            &.part-watch {
                .el-input {
                    width: 220px;
                }
            }

            &.part-passenger {
                margin-bottom: 15px;
            }
        }

        .btn-upload {
            .nucfont {
                margin-right: 4px;
                font-size: 14px;
                vertical-align: -1px;
            }
        }

        .btn-group {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 10px 0;
            text-align: center;
            background-color: #fff;
            border-top: 1px solid #eee;
            box-shadow: 0 2px 8px #ccc;

            button {
                letter-spacing: 6px;
            }
        }
    }
</style>
